<template lang="pug">
  router-view
</template>
<script>
export default {
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    }
  },
  created() {
    const localed = localStorage.getItem('locale')
    this.setLocale(localed)
  }
}
</script>
<style lang="scss">
#app {
  .v-text-field--outline {
    .v-input__slot {
      border: solid 1px #8e8e93;
      border-radius: 50px;
    }
  }
  .v-card {
    .card__title {
      font-size: 24px;
      font-weight: 500;
      text-transform: uppercase;
      padding: 30px 16px 16px;
    }
    &__text {
      .v-form {
        .upperLine {
          display: block;
          font-size: 0.82rem;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 3px;
        }
        .v-btn {
          max-width: 190px;
          height: 45px;
          margin: 0 auto;
        }
      }
    }
  }
  .v-navigation-drawer {
    text-align: center;
    .v-list {
      &__tile {
        width: 80%;
        margin: 12px auto;
      }
      &__tile--link:hover {
        background: #3182ff !important;
        border-radius: 2px;
      }
      &__tile {
        &--active {
          color: white !important;
          background: #3182ff;
          border-radius: 2px;
        }
        &__action {
          min-width: 40px;
        }
      }
    }
  }
  .v-chip {
    &__content {
      cursor: pointer;
      &:hover {
        background-color: rgba(49, 130, 255, 0.1);
        border-top: 1px solid #0d47a1;
        border-bottom: 1px solid #0d47a1;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      }
    }
  }
  .v-toolbar {
    .img-title {
      width: 48px;
      height: 48px;
    }
    &__content {
      padding-right: 0;
    }
  }
}
.theme {
  &--light {
    table {
      &.v-table {
        tbody {
          tr {
            &:hover {
              &:not(.v-datatable__expand-row) {
                background-color: #f1f1f1;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue